export { default } from "./IfAuthenticated"


// WEBPACK FOOTER //
// ./src/components/IfAuthenticated/index.ts